import { FunctionComponent } from 'react';
const DeleteAppStep: FunctionComponent = () => (<section>
    Если вы удалите запись о вашем питомце, вы не сможете получать персональные
    рекомендации и развернутые ответы специалистов в онлайн-консультациях.
  </section>);
export default DeleteAppStep;
